import DOMPurify from 'dompurify';
import {
  ALLOWED_HTML_ATTRS,
  ALLOWED_HTML_TAGS,
  FORBID_HTML_TAGS,
} from '@shared/richtext/htmlPolicy';

const IDENTITY_DISCLOSURE_HOST_PATTERN =
  /https?:\/\/(?:stmail|mail)\.qixit\.com(?:\/#)?\/identity-disclosure-requests/gi;

/** Rewrite absolute mailbox-host disclosure links to hash-relative routes on the current host. */
export function normalizeIdentityDisclosureLinks(input: string): string {
  if (!input) return '';

  return input
    .replace(IDENTITY_DISCLOSURE_HOST_PATTERN, '#/identity-disclosure-requests')
    .replace(/https?:\/\/localhost(?::\d+)?\/identity-disclosure-requests/gi, '#/identity-disclosure-requests');
}

export function sanitizeMessageHtml(input: string): string {
  if (!input) return '';

  return DOMPurify.sanitize(normalizeIdentityDisclosureLinks(input), {
    ALLOWED_TAGS: ALLOWED_HTML_TAGS,
    ALLOWED_ATTR: ALLOWED_HTML_ATTRS,
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: FORBID_HTML_TAGS,
  });
}
